import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { SpawnSelect } from './views/SpawnSelect';

const LayoutComponent = () => {
	return (
		<Fragment>
			<Background />
			<SpawnSelect />
		</Fragment>
	);
};

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.SpawnSelect)
	.build();

export default Layout;
